import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import SaasSection from '../saas/Section';
import SaasContainer from '../saas/Container';

const LandingQuoteSection = () => {
  const { t } = useTranslation();
  return (
    <SaasSection variant="wash" className="landing-section-loose !py-14 md:!py-20">
      <SaasContainer>
        <figure className="mx-auto flex max-w-3xl flex-col items-center gap-6 md:flex-row md:items-start md:gap-8 md:text-start">
          <span className="hidden h-16 w-1 shrink-0 rounded-full bg-gradient-to-b from-signal via-signal/70 to-sky-bloom md:block" aria-hidden />
          <div className="text-center md:text-start">
            <blockquote className="type-section-title text-balance text-xl leading-relaxed md:text-2xl md:leading-snug">
              {t('landing.quote')}
            </blockquote>
            <figcaption className="mt-4 text-sm font-medium text-steel md:text-base">
              {t('landing.quoteAuthor')}
            </figcaption>
            <Link
              to="/blog"
              className="mt-6 inline-flex items-center justify-center gap-2 text-sm font-semibold text-signal transition hover:text-signal-hover"
            >
              {t('landing.blogCta')}
              <ArrowRight className="h-4 w-4 shrink-0 rtl:rotate-180" aria-hidden />
            </Link>
          </div>
        </figure>
      </SaasContainer>
    </SaasSection>
  );
};

export default LandingQuoteSection;
